import * as types from '../constants'

const initialState = {
  data: [],
  count: 0,
  isLoading: false,
  error: null,
}
export default function(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_SUBDOMAIN_SUCCESS: {
      return {
        ...state,
        data: action.data,
        count: action.count,
        isLoading: false,
        error: null,
      }
    }
    case types.FETCH_SUBDOMAIN_LOADING: {
      return {
        ...state,
        isLoading: true,
      }
    }
    case types.FETCH_SUBDOMAIN_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.error,
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/subdomain.js